/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Aggregators { 
    _id?: string;
    companyName?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    phoneNumber?: string;
    domainPrefix?: string;
    licenseId?: string;
    licenseActivationDate?: Date;
    licenseExpiryDate?: Date;
    applicationId?: string;
    tenantId?: string;
    onboardingStatus?: string;
    aggregatorId?: string;
    authenticationId?: string;
    createdOnDate?: Date;
    updatedOnDate?: Date;
}